<template>
  <div class="d-flex">
    <div class="avatar avatar-md">
      <img src="/img/avatar.png" alt="avatar">
    </div>
    <div class="dropdown">
      <dropdown-button class="text-white" id="dropdownMenuButton" :text="displayAccountName" />
      <dropdown-menu aria-labelledby="dropdownMenuButton">
        <dropdown-item text="ログアウト" @click="$emit('logout')" />
      </dropdown-menu>
    </div>
  </div>
</template>

<script>
import DropdownButton from '@/views/molecules/dropdown/DropdownButton'
import DropdownMenu from '@/views/molecules/dropdown/DropdownMenu'
import DropdownItem from '@/views/molecules/dropdown/DropdownItem'
export default {
  name: "LoginUser",
  components: {
    DropdownButton,
    DropdownMenu,
    DropdownItem,
  },
  props: {
    accountName: {
      type: String,
      required: true
    },
  },
  emits: ['logout'],
  computed: {
    displayAccountName() {
      // 画面レイアウトを考慮し、16文字以降は切り捨てる（CSSのtext-truncateだとafter要素まで省略されるため、JSで対応）
      return (this.accountName.length > 16) ? (this.accountName.slice(0, 16) + '...') : this.accountName;
    },
  },
}
</script>
